import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState, GeneralProgressItemType } from './types'

// Styles
import './styles.scss'
import 'react-circular-progressbar/dist/styles.css'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import Progress from '../../components/ProgressBlock'
import LoadingPage from '../../components/LoadingPage'
import ProgressCircleItem from '../../components/ProgressCircleItem'
import ButtonFriendInvite from '../../components/ButtonFriendInvite'
import AchievementsBlock from '../../components/AchievementsBlock'
import TimeWastedBlock from '../../components/TimeWastedBlock'
import ModalInvite from '../../components/ModalInvite'

export default () => {
  const [selectedCourse, setSelectedCourse] = useState<string>('')
  const [generalProgress, setGeneralProgress] = useState<
    GeneralProgressItemType[] | null
  >(null)
  const [modalInviteFriend, setModalInviteFriend] = useState<boolean>(false)

  const dispatch = useDispatch()

  const {
    achievements,
    userState,
    courses,
    isFetchingUserState,
    isFetchingAchievements,
    isFetchingCoursesList,
    isFetchingCourse,
  } = useSelector(
    (state: { profileAchievements: InitialState }) => state.profileAchievements
  )

  const countOpenedAchievements =
    achievements?.filter(item => item.user_achievement).length || 0

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchCoursesList())
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (courses) {
      const firstCourse = courses[0]?.course_id
      setSelectedCourse(firstCourse)
    }
  }, [courses])

  useEffect(() => {
    if (selectedCourse) {
      dispatch(actions.fetchUserState(selectedCourse))
      dispatch(actions.fetchAchievements())
    }
  }, [selectedCourse])

  useEffect(() => {
    if (userState) {
      const lessonProgress =
        (userState.progress?.free?.completed || 0) +
        (userState.progress?.other?.completed || 0)
      const lessonAll =
        (userState.progress?.free?.total || 0) +
        (userState.progress?.other?.total || 0)

      const statistics: GeneralProgressItemType[] = [
        {
          title: 'Пройдено уровней',
          completeText: 'Все уровни пройдены!',
          color: '#1978B2',
          progress: userState.moduleProgress?.completed,
          all: userState.moduleProgress?.total,
        },
        {
          title: 'Пройдено уроков',
          completeText: 'Все уроки пройдены!',
          color: '#E84E25',
          progress: lessonProgress,
          all: lessonAll,
        },
        {
          title: 'Выполнено заданий',
          completeText: 'Все задания выполнены!',
          color: '#F4BA27',
          progress: userState.simpleTasksProgress?.completed,
          all: userState.simpleTasksProgress?.total,
        },
      ]
      setGeneralProgress([...statistics])
    }
  }, [userState])

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 40 }} />
          {isFetchingUserState ||
          isFetchingAchievements ||
          isFetchingCoursesList ||
          isFetchingCourse ? (
            <LoadingPage />
          ) : (
            <>
              {userState ? (
                <Progress
                  title={`Прогресс Курса «${userState.title}»: `}
                  percent={userState.progress.other.percent || 0}
                  style={{ marginBottom: 40 }}
                />
              ) : null}
              {generalProgress ? (
                <div className={'profile-achievements__row'}>
                  {generalProgress.map((item, index) => (
                    <ProgressCircleItem item={item} key={index} />
                  ))}
                </div>
              ) : null}
              {userState && userState.simpleTasksProgress.time ? (
                <TimeWastedBlock
                  timestamp={userState.simpleTasksProgress.time}
                />
              ) : null}
              {achievements && userState ? (
                <AchievementsBlock
                  title={`«${userState.title}»`}
                  achievements={achievements}
                  countOpened={countOpenedAchievements}
                />
              ) : null}
              <ButtonFriendInvite
                styles={{ marginBottom: 40 }}
                onClick={() => setModalInviteFriend(true)}
              />
            </>
          )}
        </div>
      </div>
      <Footer />
      <ModalInvite
        modal={modalInviteFriend}
        typeInvite={'friend'}
        isReverse={false}
        alertDescription={'Поделитесь ей с другом!'}
        onClose={() => setModalInviteFriend(false)}
      />
    </>
  )
}
